export default __webpack_public_path__ + "static/media/caret-down-grey.3b3041a8.svg";